// extracted by mini-css-extract-plugin
export var hideEditor = "_ja-2";
export var infoIcon = "_ja-3";
export var label = "_ja-1";
export var labelContainer = "_ja-0";
export var readonlyText = "_ja-4";